import { render, staticRenderFns } from "./VueModal.vue?vue&type=template&id=59e6b75a&scoped=true"
import script from "./VueModal.vue?vue&type=script&lang=js"
export * from "./VueModal.vue?vue&type=script&lang=js"
import style0 from "./VueModal.vue?vue&type=style&index=0&id=59e6b75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6b75a",
  null
  
)

export default component.exports